import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';

import { Route, Routes, Navigate } from 'react-router-dom';
import Scroll from './component/scroll_to_top/scroll';
import Homepage from './component/homepage/homepage';
import Homepage2 from './component/homepage/homepage2';
import Article from './component/article/article';
import SellWatch from './component/sellwatch/sellwatch';
import ContactUs from './component/contactus/contact';
import ArticleList from './component/article/articleList';
import Vintage from './component/collection/vintage';
import Rolex from './component/collection/rolex';
import Archive from './component/collection/archive';
import ProductDetail from './component/product_detail/pd';
import PdContact from './component/product_detail/pd_contact';
import Archivepd from './component/collection/archive_pd';
import Vintagepd from './component/collection/vintage_pd';
import Rolexpd from './component/collection/rolex_pd';
import Rolexpurchase from './component/collection/rolex_purchase';
import Vintagepurchase from './component/collection/vintage_purchase';
import Privacy from './component/privacy/privacy';
import Rolex_vintage from './component/collection/rolex_vintage';
import PageLayout from './component/pagelayout/layout';
import Blog from './component/blog/blog';
import BlogList from './component/blog/blogList';
import Watch_Part from './component/collection/watch_part';
import Watch_parts_pd from './component/collection/watch_part_pd';
import Watch_part_purchase from './component/collection/watch_part_purchase';
import { Login } from './component/auth/login';
import { Register } from './component/auth/register';
import { TwoFactorAuthentication } from './component/auth/twoFactorAuthentication';
import { ForgotPassword } from './component/auth/forgotPassowrd';
import { ResetPassword } from './component/auth/resetPassword';
import Profile from './component/auth/profile';
import ChangePassword from './component/auth/changePassword';
import VerifyEmail from './component/auth/verifyEmail';
import PrivateRoute from './component/auth/authdirect';
import AuthPage from './component/homepage/authPage';
function App() {
  return (
    <div className="App">
      <Routes>
      <Route path="/" element={<Homepage />} />
        {/* Public Auth Routes — outside PageLayout */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:id/:token" element={<ResetPassword />} />
        <Route path="/verify-email/:id/:token" element={<VerifyEmail />} />
        <Route path="/two-factor-authentication" element={<TwoFactorAuthentication />} />

        {/* All main pages wrapped in PageLayout */}
        <Route element={<PageLayout />}>
          {/* Public routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/introduction" element={<Homepage2 />} />
          <Route path="/authPage" element={<AuthPage />} />
         
          <Route path="/rolex" element={<Rolex />} />
          <Route path="/rolexdetail" element={<Rolexpd />} />
          <Route path="/rolexpurchase" element={<Rolexpurchase />} />
          <Route path="/vintage" element={<Vintage />} />
          <Route path="/watches/:id/:title" element={<Vintagepd />} />
          <Route path="/purchase-watch/:id/:title" element={<Vintagepurchase />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/archivedetail" element={<Archivepd />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blogs/:id/:title" element={<BlogList />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/sell-your-watch" element={<SellWatch />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/productdetail" element={<ProductDetail />} />
          <Route path="/productdetailcontact" element={<PdContact />} />
          <Route path="/vintage-rolex-watches" element={<Rolex_vintage />} />
          <Route path="/watches-and-parts" element={<Watch_Part />} />
          <Route path="/watches-and-parts/:id/:title" element={<Watch_parts_pd />} />
          <Route path="/purchase-watches-and-parts/:id/:title" element={<Watch_part_purchase />} />

          {/* Protected routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/profile" element={<Profile />} />
            <Route path="/archive-articles" element={<Article />} />
            <Route path="/articles/:id/:title" element={<ArticleList />} />
          </Route>
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Scroll />
    </div>
  );
}

export default App;
